<script>
    import { onMount } from 'svelte';
    import {router} from 'tinro';
    import {api} from './../lib/api.js';
    import{mdiFolderOutline,mdiFileOutline} from '@mdi/js';
    import {Icon} from 'svelte-chota';

    let params = router.params();   
    let dir = params.project; 

    let path = '/';

    let files = [];
    onMount(_=>{
        fetchFiles();
    });

    function changePath(newpath){
        path = newpath;
        fetchFiles();
    }

    async function fetchFiles(){
        files = await api.get(`/project/${dir}/files?path=${path}`);
    }
</script>


<table>
    <tr>
        <th>File</th>
        <th>Modified</th>
    </tr>
    {#if path !== '/'}
    <tr>

        <td><span class="folder" on:click={()=>changePath(path.split('/').slice(0,-1).join('/'))}><Icon src={mdiFolderOutline} size="2"/>..</span></td>
        <td></td>
    </tr>
    {/if}
    {#each files as file}
        <tr>
            {#if file.dir}
            <td><span class="folder" on:click={()=>changePath(`${path}/${file.name}`)}><Icon src={mdiFolderOutline} size="2"/> {file.name}</span></td>
            {:else}
            <td><Icon src={mdiFileOutline} size="2"/> {file.name}</td>    
            {/if}
            <td>{file.modified.replace('T',' ').replace(/\.\d+Z/,'')}</td>
        </tr>
    {/each}
</table>

<style>
    .folder{
        cursor: pointer;
    }

    .folder:hover{
        color: var(--color-primary);
    }
</style>